import { render, staticRenderFns } from "./wxPay.vue?vue&type=template&id=184ed3af&scoped=true&"
import script from "./wxPay.vue?vue&type=script&lang=js&"
export * from "./wxPay.vue?vue&type=script&lang=js&"
import style0 from "./wxPay.vue?vue&type=style&index=0&id=184ed3af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184ed3af",
  null
  
)

export default component.exports